export const QA_NAME_LISTING_PROFILE_KEY_FACTS_WIDGET = 'listingKeyFacts'

export const QA_NAME_LISTING_PROFILE_KEY_FACTS_DISCARD =
  'listingKeyFactsDiscard'

export const LISTING_PROFILE_KEY_FACT = {
  area: 'area',
  deposit: 'deposit',
  heatingCosts: 'heating_costs',
  otherCosts: 'other_costs',
  rentCold: 'rent_cold',
  rentWarm: 'rent_warm',
  rooms: 'rooms',
  serviceCharge: 'service_charge',
}

export const LISTING_PROFILE_KEY_FACT_LABEL_KEY = {
  [LISTING_PROFILE_KEY_FACT.area]: 'RentalPortal.ListingProfileAreaLabelKey',
  [LISTING_PROFILE_KEY_FACT.deposit]:
    'RentalPortal.ListingProfileDepositLabelKey',
  [LISTING_PROFILE_KEY_FACT.heatingCosts]:
    'RentalPortal.ListingProfileHeatingCostsLabelKey',
  [LISTING_PROFILE_KEY_FACT.otherCosts]:
    'RentalPortal.ListingProfileOtherCostsLabelKey',
  [LISTING_PROFILE_KEY_FACT.rentCold]:
    'RentalPortal.ListingProfileRentColdLabelKey',
  [LISTING_PROFILE_KEY_FACT.rentWarm]:
    'RentalPortal.ListingProfileRentWarmLabelKey',
  [LISTING_PROFILE_KEY_FACT.rooms]: 'RentalPortal.ListingProfileRoomsLabelKey',
  [LISTING_PROFILE_KEY_FACT.serviceCharge]:
    'RentalPortal.ListingProfileServiceChargeLabelKey',
}

export const LISTING_PROFILE_KEY_FACTS_FIELD_NAME_HEATING_COSTS =
  'heating_costs'

export const LISTING_PROFILE_KEY_FACTS_FIELD_NAME_HEATING_COSTS_INCLUDED =
  'heating_costs_included'

export const LISTING_PROFILE_KEY_FACTS_FIELD_NAME_OTHER_COSTS = 'other_costs'

export const LISTING_PROFILE_KEY_FACTS_PLACEHOLDER_KEY = {
  [LISTING_PROFILE_KEY_FACTS_FIELD_NAME_HEATING_COSTS]:
    'RentalPortal.ListingProfileHeatingCostsPlaceholderKey',
  [LISTING_PROFILE_KEY_FACTS_FIELD_NAME_OTHER_COSTS]:
    'RentalPortal.ListingProfileOtherCostsPlaceholderKey',
}

export const LISTING_PROFILE_KEY_FACTS_DISCARD_CONFIRMATION_PROPS = {
  description: 'RentalPortal.ListingProfileKeyFactsDiscardTextKey',
  qaName: QA_NAME_LISTING_PROFILE_KEY_FACTS_DISCARD,
  title: 'RentalPortal.ListingProfileBlockDiscardTitleKey',
}
